"use strict";

var LoggerInstance = require("js-logger").get("SubscriptionHelper");

var AccountFormHelper = require("../accountComponents/AccountFormHelper");
var SmartyStreets = require("../accountComponents/SmartyStreets");
var PledgeStatementHelper = require("../accountComponents/PledgeStatementHelper");

var ActionsHelper = require("../actions/ActionsHelper");

var CheckoutApi = require("../checkoutComponents/CheckoutApi");

var Spinner = require("../client/Spinner");

var ValidationHelper = require("../commonComponents/ValidationHelper");

var WizardConstants = require("../constants/WizardConstants");

var Constants = require("../designer/Constants");

var BootstrapPrompt = require("../shared/BootstrapPrompt");
var InputHelper = require("../shared/InputHelper");

var StoresHelper = require("../stores/StoresHelper");

var SubscriptionHelper = {
	addToCart: function (event) {
		if (!ActionsHelper.getEventOrReturn(event, /*isDesignMode*/false)) {
			return false;
		}

		var isInPledgeStatementSession = this.isInPledgeStatementSession;
		var pledgeStatementEntryWizard = this[WizardConstants.WIZARDS.PLEDGE_STATEMENT_ENTRY];

		PledgeStatementHelper.confirmAbandonPledgeStatementSession(isInPledgeStatementSession, pledgeStatementEntryWizard).done(() => {
			try {
				//Validation
				var components = [
					$("[data-component='subscription']")
				];

				Spinner.showSpinner();
				ValidationHelper.validate({ components }).always(isValid => {
					if (!isValid) {
						LoggerInstance.error("Validation Failed to add to cart in SubscriptionHelper.");
						Spinner.removeSpinner();
						return false;
					}

					this.verifySmartyStreets().done(() => {
						var shoppingCartData = this.getShoppingCartData();
						CheckoutApi.addToCart({ cartItems: shoppingCartData }).done((addToCartResponse) => {
							if (addToCartResponse.success) {
								//Unlike the other addToCart buttons, the subscription addToCart button is only available on the subscription detail page and there are no options to go anywhere else but the shopping cart page.
								window.location = "/shoppingcart";
							} else if (addToCartResponse.message) {
								//This should be a constituent-safe message
								BootstrapPrompt.alert(addToCartResponse.message);

								Spinner.removeSpinner();
							} else {
								BootstrapPrompt.alert(StoresHelper.getWizardValue(
									this[WizardConstants.WIZARDS.SHOPPING_CART_MESSAGES],
									WizardConstants.SHOPPING_CART_MESSAGE_FIELDS.ADD_TO_CART_ERROR,
									{ tangibleType: "subscription" }
								));
								Spinner.removeSpinner();
							}
						}).fail(() => {
							BootstrapPrompt.alert(StoresHelper.getWizardValue(
								this[WizardConstants.WIZARDS.SHOPPING_CART_MESSAGES],
								WizardConstants.SHOPPING_CART_MESSAGE_FIELDS.ADD_TO_CART_ERROR,
								{ tangibleType: "subscription" }
							));
							Spinner.removeSpinner();
						});
					}).fail(() => Spinner.removeSpinner());
				});
			} catch (exception) {
				LoggerInstance.error(exception);
				Spinner.removeSpinner();
			}
			return false;
		});
	},
	autoRenewSelected: function(event, $checkboxInput) {
		if (!event) {
			return;
		}

		if (!$checkboxInput.length || $checkboxInput.is(":disabled")) {
			return;
		}

		var $subscriptionComponent = $checkboxInput.closest("[data-component='subscription']");
		var $allAutoRenewCheckboxesInSubscription = $subscriptionComponent.find("input[data-component='autoRenewCheckbox.input']");

		//Set all the other autoRenewCheckboxes in this subscription component to the same as the one that was just checked.
		$allAutoRenewCheckboxesInSubscription.prop("checked", $checkboxInput.is(":checked"));

		//This fixes problems when the autoRenewCheckbox is inside the subscriptionPriceCodes component.
		event.stopPropagation();
	},

	getSelectedAddress: function($otherAddressSelector) {
		var $selectedOption = $otherAddressSelector.find("option:selected");
		if (!$selectedOption.length) {
			$selectedOption = $otherAddressSelector.find("option").first();
		}

		if (!$selectedOption.length) {
			return null;
		}

		return {
			city: $selectedOption.attr("data-city"),
			country: $selectedOption.attr("data-country"),
			id: Number($selectedOption.attr("value")),
			line1: $selectedOption.attr("data-line1"),
			line2: $selectedOption.attr("data-line2"),
			line3: $selectedOption.attr("data-line3"),
			line4: $selectedOption.attr("data-line4"),
			postalCode: $selectedOption.attr("data-postal-code"),
			state: $selectedOption.attr("data-state")
		};
	},

	getSelectedEmail: function($otherEmailSelector) {
		var $selectedOption = $otherEmailSelector.find("option:selected");
		if (!$selectedOption.length) {
			$selectedOption = $otherEmailSelector.find("option").first();
		}

		if (!$selectedOption.length) {
			return null;
		}

		return {
			emailAddress: $selectedOption.attr("data-email"),
			id: Number($selectedOption.attr("value")),
			type: $selectedOption.attr("data-type")
		};
	},

	getShoppingCartData: function() {
		var subscriptionData = {
			subscriptionCode: window.tangibleCode
		};

		var $subscriptionComponent = $("[data-component='subscription']");

		var subscriptionAccountData = AccountFormHelper.serializeCreateAccountFormOnly({
			accountFormId: $subscriptionComponent.find("[data-component='createAccountForm']").attr("id")
		});
		subscriptionData.account = subscriptionAccountData;

		subscriptionData = Object.assign(subscriptionData, {
			autoRenewChecked: $subscriptionComponent.find("[data-component='autoRenewCheckbox'] input").first().is(":checked"),
			otherAddressId: $subscriptionComponent.find("[data-component='otherAddressDropdown.selector']:visible").first().find("option:selected").val(),
			otherEmailId: $subscriptionComponent.find("[data-component='otherEmailDropdown.selector']:visible").first().find("option:selected").val(),
			priceCode: $subscriptionComponent.find("[data-component='subscriptionPriceCodes.singlePriceCode'].selected").first().attr("data-price-code"),
			quantity: $subscriptionComponent.find("[data-component='subscriptionQuantity']").val() || 1,
			startDate: $subscriptionComponent.find("[data-component='subscriptionStartDate']").val(),
			subscriptionNote: $subscriptionComponent.find("[data-component='subscriptionNote']").val(),
			thisIsMeChecked: $subscriptionComponent.find("[data-component='thisIsMeCheckbox'] input").first().is(":checked")
		});
		return { subscriptions: [subscriptionData] };
	},

	initialize: function(options) {
		options = options || {};

		this.accountData = options.accountData;
		this.isInPledgeStatementSession = options.isInPledgeStatementSession;
		this.organizationPrimaryContact = options.organizationPrimaryContact;
		this.wizardDateFormat = options.wizardDateFormat || {};
		this[WizardConstants.WIZARDS.PLEDGE_STATEMENT_ENTRY] = options[WizardConstants.WIZARDS.PLEDGE_STATEMENT_ENTRY] || {};
		this[WizardConstants.WIZARDS.SUBSCRIPTION_DISPLAY_MESSAGES] = options[WizardConstants.WIZARDS.SUBSCRIPTION_DISPLAY_MESSAGES] || {};
		this[WizardConstants.WIZARDS.SHOPPING_CART_MESSAGES] = options[WizardConstants.WIZARDS.SHOPPING_CART_MESSAGES] || {};

		var $subscriptionComponent = $("[data-component='subscription']").first();
		var $firstCreateAccountForm = $subscriptionComponent.find("[data-component='createAccountForm']").first();
		this.accountUpdateAllowed = $firstCreateAccountForm.is("[data-update-allowed]");

		//If we are Unidentified, we want to allow updating data.
		if (!this.accountData) {
			this.accountUpdateAllowed = true;
			this._setFieldDisableStatus($subscriptionComponent, /*isDisabled*/false);
		}

		$firstCreateAccountForm.attr("data-update-allowed", true);

		//Initialize AddToCart Buttons
		$("[data-component='addSubscriptionToCartButton']").off("click.subscriptionPurchase").on("click.subscriptionPurchase", (event) => this.addToCart(event));

		$(document).ready(() => {
			this.initializeSubscriptionComponent(options);
			this.initializeSubscriptionPromotionalCodeComponent(
				$("[data-component='applyPromotionalCodeForm']"),
				options.layoutId
			);

			var $firstThisIsMe = $subscriptionComponent.find("input[data-component='thisIsMeCheckbox.input']").first();
			if ($subscriptionComponent.find("[data-component='thisIsMeCheckbox']").attr("data-is-first-checked-by-default") === "true") {
				if ($firstThisIsMe.is(":checked")) {
					//Uncheck and then check again to make sure the appropriate events were triggered
					$firstThisIsMe.click();
				}
				$firstThisIsMe.click();
			} else if ($firstThisIsMe.is(":checked")) {
				//It was checked, but it shouldn't be
				$firstThisIsMe.click();
			} else {
				this._setFieldDisableStatus($subscriptionComponent, /*isDisabled*/false);
			}
		});
	},

	initializeOtherAddressDropdownComponents: function($subscriptionComponent) {
		$subscriptionComponent = $($subscriptionComponent || "[data-component='subscription']");

		var isThisIsMeChecked = $subscriptionComponent.find("[data-component='thisIsMeCheckbox.input']").first().is(":checked");

		$subscriptionComponent.find("[data-component='otherAddressDropdown']").each((index, otherAddressDropdown) => {
			var $otherAddressDropdown = $(otherAddressDropdown);
			var $selector = $otherAddressDropdown.find("[data-component='otherAddressDropdown.selector']");
			//Hide the other address dropdown if this is me is not checked
			if (!isThisIsMeChecked) {
				$otherAddressDropdown.hide();
			} else {
				$otherAddressDropdown.show();
				this.setOtherAddress($subscriptionComponent, $selector);
			}
			$selector.off("change.otherAddressDropdown");
			//Setting a change listener on the other address dropdown select
			$selector.on("change.otherAddressDropdown", () => {
				//If there are any other other address dropdowns on the page, making sure they all match in value
				$subscriptionComponent.find("[data-component='otherAddressDropdown.selector']").not($selector).each((otherSelectIndex, otherSelectElement) => {
					otherSelectElement.value = $selector.val();
				});
				this.setOtherAddress($subscriptionComponent, $selector);
			});
		});
	},

	initializeOtherEmailDropdownComponents: function($subscriptionComponent) {
		$subscriptionComponent = $($subscriptionComponent || "[data-component='subscription']");

		var isThisIsMeChecked = $subscriptionComponent.find("[data-component='thisIsMeCheckbox.input']").first().is(":checked");

		$subscriptionComponent.find("[data-component='otherEmailDropdown']").each((index, otherEmailDropdown) => {
			var $otherEmailDropdown = $(otherEmailDropdown);
			var $selector = $otherEmailDropdown.find("[data-component='otherEmailDropdown.selector']");
			//Hide the other email dropdown if this is me is not checked
			if (!isThisIsMeChecked) {
				$otherEmailDropdown.hide();
			} else {
				$otherEmailDropdown.show();
				this.setOtherEmail($subscriptionComponent, $selector);
			}
			$selector.off("change.otherEmailDropdown");
			//Setting a change listener on the other email dropdown select
			$selector.on("change.otherEmailDropdown", () => {
				//If there are any other other email dropdowns on the page, making sure they all match in value
				$subscriptionComponent.find("[data-component='otherEmailDropdown.selector']").not($selector).each((otherSelectIndex, otherSelectElement) => {
					otherSelectElement.value = $selector.val();
				});
				this.setOtherEmail($subscriptionComponent, $selector);
			});
		});
	},

	initializeSubscriptionComponent: function (options) {
		options = options || {};
		var $subscriptionComponent = $("[data-component='subscription']");

		//InitializePhoneNumberInput
		var defaultCountry = ((this.accountData || {}).address || {}).country;
		window.AccountActions.initializePhoneNumberGroupComponent(defaultCountry, $subscriptionComponent.find("[data-component='createAccountForm']"));

		//initializing the thisIsMeCheckbox component
		$subscriptionComponent.find("[data-component='thisIsMeCheckbox']").each((index, checkbox) => {
			var $checkbox = $(checkbox);
			var $input = $checkbox.find("[data-component='thisIsMeCheckbox.input']");
			//Removing for on label because the whole thisIsMeCheckbox is clickable
			$checkbox.find("label[data-child-of='thisIsMeCheckbox']").removeAttr("for");
			//Adding the click event listener
			$input.off("click.thisIsMe");
			$input.on("click.thisIsMe", (event) => {
				this.thisIsMeSelected(event, $input);
			});

			$checkbox.off("click.thisIsMe");
			$checkbox.on("click.thisIsMe", (event) => {
				if ($input.is(":disabled")) {
					return;
				}
				$input.prop("checked", !$input.prop("checked"));
				this.thisIsMeSelected(event, $input);
			});

			$checkbox.find("*").add($checkbox).css("cursor", "pointer");
		});

		$subscriptionComponent.find("[data-component='autoRenewCheckbox']").each((index, checkbox) => {
			var $checkbox = $(checkbox);
			var $input = $checkbox.find("[data-component='autoRenewCheckbox.input']");
			//Removing for on label because the whole autoRenew is clickable
			$checkbox.find("label[data-child-of='autoRenewCheckbox']").removeAttr("for");

			// If the subscription doesn't support auto-renew, disable.
			if (!options.supportsAutoRenew) {
				$input
					.prop("checked", false)
					.prop("disabled", true);
			} else {
				//Adding the click event listener
				$input.off("click.autoRenew");
				$input.on("click.autoRenew", (event) => {
					this.autoRenewSelected(event, $input);
				});

				$checkbox.off("click.autoRenew");
				$checkbox.on("click.autoRenew", (event) => {
					if ($input.is(":disabled")) {
						return;
					}
					$input.prop("checked", !$input.prop("checked"));
					this.autoRenewSelected(event, $input);
				});

				$checkbox.find("*").add($checkbox).css("cursor", "pointer");
			}
		});

		this.initializeSubscriptionPriceCodesComponent();

		this.initializeOtherAddressDropdownComponents($subscriptionComponent);

		this.initializeOtherEmailDropdownComponents($subscriptionComponent);

		//Initialize the Subscription Quantity component
		InputHelper.initializeIntegerInput({
			$component: $subscriptionComponent,
			defaultValue: 1,
			greaterThanZero: true,
			numberSelector: "[data-component='subscriptionQuantity']"
		});

		//Initializing the quantity component value to 1.
		$("[data-component='subscriptionQuantity']").val(1);

		//Initialize the Subscription Start Date component(s)
		InputHelper.initializeDates({
			$component: $subscriptionComponent,
			dateSelector: "[data-component='subscriptionStartDate']",
			wizardDateFormat: this.wizardDateFormat.dateFormat
		});

		//Adding custom validator for Start Date for when add to cart is clicked
		$subscriptionComponent.find("[data-component='subscriptionStartDate']").each((index, element) => {
			var $element = $(element);
			$element.attr("data-has-custom-validator", true).data({
				customValidator: () => {
					var errorMessages = [];
					var startDate = $element.val();

					//coersion, want to be true if not null and not undefined and not empty string; that is the only time I want to do the validation
					if (startDate != null && startDate != "") {
						errorMessages = InputHelper.validateStartAndEndDates({
							dateFormat: this.wizardDateFormat.dateFormat,
							startDate,
							startDateInvalidMessage: this[WizardConstants.WIZARDS.SUBSCRIPTION_DISPLAY_MESSAGES].startDateInvalid
						}) || [];
					}

					return {
						errorMessages,
						isValid: !errorMessages.length
					};
				}
			});
		});

		SmartyStreets.initializeForSubscriptionPurchase($subscriptionComponent.find("[data-component='createAccountForm']").attr("id"));
	},

	initializeSubscriptionPriceCodesComponent: function($component, isDesignMode) {
		$component = $($component || "body");

		if ($component.is("[data-component='subscriptionPriceCodes']")) {
			$component.attr("data-partial", `prices-${$component.attr("id")}`);
		}

		var $singlePriceCodeComponents = $component.find("[data-component='subscriptionPriceCodes.singlePriceCode']");

		//Setting up the click listeners to change the selected class
		$singlePriceCodeComponents.off("click.subscriptionPriceCodes");
		$singlePriceCodeComponents.off("keyup.subscriptionPriceCodes");

		$singlePriceCodeComponents.on("click.subscriptionPriceCodes", (event) => {
			this.priceCodeClicked(event, isDesignMode);
		});
		$singlePriceCodeComponents.on("keyup.subscriptionPriceCodes", (event) => {
			if (event && (event.which === Constants.KEYS.ENTER || event.which === Constants.KEYS.SPACE)) {
				this.priceCodeClicked(event, isDesignMode);
			}
		});

		if (!isDesignMode) {
			$singlePriceCodeComponents.first().addClass("selected");
		}
	},

	initializeSubscriptionPromotionalCodeComponent: function ($promoCodeFormComponent, layoutId) {
		if (!$promoCodeFormComponent || !$promoCodeFormComponent.length) {
			return;
		}

		var $form = $promoCodeFormComponent.find("form");

		// make form id unique
		var componentId = $promoCodeFormComponent.attr("id");
		var formId = $form.attr("id");
		var $submitButton = $form.find("[data-component='submitButton']");

		var newId = `${formId}_${componentId}`;

		$form.attr("id", newId);
		$submitButton.attr("form", newId);

		$form.off("submit.promotionalCodeForm");
		$form.on("submit.promotionalCodeForm", (event) => {
			event.preventDefault();
			event.stopPropagation();

			var $formInput = $promoCodeFormComponent.find("[data-component='applyPromotionalCodeForm.input']");
			var promotion = $formInput.val().toUpperCase();
			var subscription = window.tangibleCode;
			var $priceComponent = $("[data-component='subscriptionPriceCodes']");

			if (!promotion) {
				return;
			}

			$formInput.val("");

			// trigger price code refresh
			$priceComponent.load(`/subscriptions/${subscription}/prices?layoutId=${layoutId}&id=${$priceComponent.attr("id")}&promotion=${promotion} .subscription-price-codes-wrapper`, (response, status) => {
				if (status !== "error") {
					this.initializeSubscriptionPriceCodesComponent($priceComponent, false);

					var appliedPromotion = $(response).attr("data-promotion");

					var $currentPromotionalCode = $("[data-component='currentPromotionalCode']");
					if (appliedPromotion) {
						$currentPromotionalCode.find("[data-dynamic='PromotionalCode']").html(promotion);
						$currentPromotionalCode.show();
					} else {
						$currentPromotionalCode.find("[data-dynamic='PromotionalCode']").html("");
						$currentPromotionalCode.hide();
					}
				}
			});

			return false;
		});
	},

	removePromotionalCode(event, isDesignMode, layoutId) {
		event = this._getEventOrReturn(event, "Remove promotional code clicked successfully", isDesignMode);
		if (!event) {
			return;
		}

		event.preventDefault();
		event.stopPropagation();

		var subscription = window.tangibleCode;
		var $priceComponent = $("[data-component='subscriptionPriceCodes']");

		var $currentPromotionalCode = $("[data-component='currentPromotionalCode']");
		$currentPromotionalCode.hide();

		$priceComponent.load(`/subscriptions/${subscription}/prices?layoutId=${layoutId}&id=${$priceComponent.attr("id")}&promotion= .subscription-price-codes-wrapper`, (response, status) => {
			if (status !== "error") {
				this.initializeSubscriptionPriceCodesComponent($priceComponent, false);
			}
		});

		return false;
	},

	priceCodeClicked: function(event, isDesignMode) {
		//When a price code is clicked, we just need to change the selected class
		var $singlePriceCode = $(event.target).closest("[data-component='subscriptionPriceCodes.singlePriceCode']");

		if ((isDesignMode && (event.ctrlKey || event.metaKey)) || (!isDesignMode && !$singlePriceCode.hasClass("selected"))) {
			$singlePriceCode.toggleClass("selected");
			$singlePriceCode.closest("[data-component='subscriptionPriceCodes']").find("[data-component='subscriptionPriceCodes.singlePriceCode']").not($singlePriceCode).removeClass("selected");
		}

		//This is below because we want all that is above to occur in the designer and the constituent page.
		//	Have this below to show the message that the price code has been clicked.
		this._getEventOrReturn(event, "Single Subscription Price Code Clicked", isDesignMode);
	},

	setOtherAddress: function($subscriptionComponent, $otherAddressSelector) {
		var selectedAddress = this.getSelectedAddress($otherAddressSelector) || {};

		var $createAccountForm = $subscriptionComponent.find("[data-component='createAccountForm']");
		var createAccountFormId = $createAccountForm.attr("id");

		var id = selectedAddress.id || 0;
		if (id <= 0) {
			this._setAddressDisableStatus($subscriptionComponent, /*isDisabled*/false);
			this._clearAddressData($subscriptionComponent, createAccountFormId);
		} else {
			this._setAccountData({
				address: selectedAddress,
				onlyAddressData: true
			}, $subscriptionComponent, createAccountFormId);
			this._setAddressDisableStatus($subscriptionComponent, /*isDisabled*/true);
		}
	},

	setOtherEmail: function($subscriptionComponent, $otherEmailSelector) {
		var selectedEmail = this.getSelectedEmail($otherEmailSelector) || {};

		var $createAccountForm = $subscriptionComponent.find("[data-component='createAccountForm']");
		var createAccountFormId = $createAccountForm.attr("id");

		var id = selectedEmail.id || 0;
		if (id <= 0) {
			this._setEmailDisableStatus($subscriptionComponent, /*isDisabled*/false);
			this._clearEmailData($subscriptionComponent, createAccountFormId);
		} else {
			this._setAccountData({
				email: selectedEmail,
				onlyEmailData: true
			}, $subscriptionComponent, createAccountFormId);
			this._setEmailDisableStatus($subscriptionComponent, /*isDisabled*/true);
		}
	},

	thisIsMeSelected: function(event, $checkboxInput) {
		if (!event) {
			return;
		}

		if (!$checkboxInput.length || $checkboxInput.is(":disabled")) {
			return;
		}

		var $subscriptionComponent = $checkboxInput.closest("[data-component='subscription']");
		var $allThisIsMeCheckboxesInSubscription = $subscriptionComponent.find("input[data-component='thisIsMeCheckbox.input']");
		var $createAccountForm = $subscriptionComponent.find("[data-component='createAccountForm']");
		var createAccountFormId = $createAccountForm.attr("id");
		var $otherAddressDropdowns = $subscriptionComponent.find("[data-component='otherAddressDropdown']");
		var $otherEmailDropdowns = $subscriptionComponent.find("[data-component='otherEmailDropdown']");

		//Set all the other thisIsMeCheckboxes in this subscription component to the same as the one that was just checked.
		$allThisIsMeCheckboxesInSubscription.prop("checked", $checkboxInput.is(":checked"));

		//This fixes problems when the thisIsMeCheckbox is inside the subscriptionPriceCodes component.
		event.stopPropagation();
		//We do not have accountData, meaning we are unidentified, so after we set all the other thisIsMe checkboxes the same, we should return.
		if (!this.accountData) {
			return;
		}

		var accountData = Object.assign({}, this.accountData);

		//We are checking the otherAddressDropdown component, if one exists on the page
		var selectedAddress = this.getSelectedAddress($otherAddressDropdowns.first().find("[data-component='otherAddressDropdown.selector']"));
		var isAddressSelected = false;
		var emptyAddressSelected = false;
		if (selectedAddress) {
			if (selectedAddress.id > 0) {
				accountData.address = selectedAddress;
				isAddressSelected = true;
			} else if (selectedAddress.id === 0) {
				accountData.address = {};
				emptyAddressSelected = true;
			}
		}

		//We are checking the otherAddressDropdown component, if one exists on the page
		var selectedEmail = this.getSelectedEmail($otherEmailDropdowns.first().find("[data-component='otherEmailDropdown.selector']"));
		var isEmailSelected = false;
		var emptyEmailSelected = false;
		if (selectedEmail) {
			if (selectedEmail.id > 0) {
				accountData.email = selectedEmail;
				isEmailSelected = true;
			} else if (selectedEmail.id === 0) {
				accountData.email = {};
				emptyEmailSelected = true;
			}
		}

		if ($checkboxInput.is(":checked")) {
			$otherAddressDropdowns.show();
			$otherEmailDropdowns.show();
			//Do we have existing data on the form, if so, save it
			//Save previously entered data
			this.savedThisIsMeValues = this._serializeSubscriptionPurchaseData($subscriptionComponent);

			this._clearSubscriptionPurchaseData($subscriptionComponent, createAccountFormId);

			//This is the first checkbox input.  If we have account data, set it.
			this._setAccountData(accountData, $subscriptionComponent, createAccountFormId);

			//If update is not allowed, we should set the fields to disabled
			if (!this.accountUpdateAllowed) {
				this._setFieldDisableStatus($subscriptionComponent, /*isDisabled*/true);
			}

			if (isAddressSelected) {
				//If we have an otherAddressDropdown component and one is selected, we are disabling the address fields.
				this._setAddressDisableStatus($subscriptionComponent, /*isDisabled*/true);
			} else if (emptyAddressSelected) {
				//If the empty address is selected, we have to be sure that the address fields are enabled
				this._setAddressDisableStatus($subscriptionComponent, /*isDisabled*/false);
			}

			if (isEmailSelected) {
				//If we have an otherEmailDropdown component and one is selected, we are disabling the address fields.
				this._setEmailDisableStatus($subscriptionComponent, /*isDisabled*/true);
			} else if (emptyEmailSelected) {
				//If the empty address is selected, we have to be sure that the address fields are enabled
				this._setEmailDisableStatus($subscriptionComponent, /*isDisabled*/false);
			}

			//Need to set the address as verified for SmartyStreets
			$createAccountForm.find("form")
				.attr(Constants.ADDRESS_VERIFICATION_STATUSES_ATTRIBUTES.VERIFIED, "true")
				.removeAttr(Constants.ADDRESS_VERIFICATION_STATUSES_ATTRIBUTES.USER_CERTIFIED)
				.removeAttr(Constants.ADDRESS_VERIFICATION_STATUSES_ATTRIBUTES.ERROR);
		} else {
			$otherAddressDropdowns.hide();
			$otherEmailDropdowns.hide();
			//Clear the data
			this._clearSubscriptionPurchaseData($subscriptionComponent, createAccountFormId);

			var savedFormData = this.savedThisIsMeValues;
			//Do we have previous saved data
			if (savedFormData) {
				this._setAccountData(savedFormData, $subscriptionComponent, createAccountFormId);
			}
		}
	},

	verifySmartyStreets: function(ids, deferred) {
		//We could be verifying multiple address components.
		deferred = deferred || new $.Deferred();

		if (ids == null) { //coercion because I want both null and undefined
			ids = $("[data-component='subscription'] [data-component='createAccountForm']").filter((index, element) => {
				return $(element).find("[data-component='accountAddressLine1']:enabled").length;
			}).toArray().map(element => $(element).attr("id"));
		}

		ids = ids || [];
		if (ids.length) {
			SmartyStreets.verifyAddress(`subscription${ids[0]}`).done(() => {
				ids.splice(0, 1);
				this.verifySmartyStreets(ids, deferred);
			}).fail(() => {
				deferred.reject();
			});
		} else {
			deferred.resolve();
		}
		return deferred;
	},

	_clearAddressData($subscriptionComponent, formParentId) {
		this._setAddressDisableStatus($subscriptionComponent, /*isDisabled*/false);

		$subscriptionComponent.find("[data-component='accountAddressLine1'],[data-component='accountAddressLine2'],[data-component='accountAddressLine3'],[data-component='accountAddressLine4'],[data-component='accountAddressCity'],[data-component='accountAddressPostalCode']")
							.val("");
		window.AccountActions.setSelectedCountry(formParentId, window.AccountStore.getDefaultCountry());
		window.AccountActions.setSelectedState(formParentId, "");

		ValidationHelper.removeBetterValidationPopup($subscriptionComponent.find("[data-component='accountAddressLine1'],[data-component='accountAddressLine2'],[data-component='accountAddressLine3'],[data-component='accountAddressLine4'],[data-component='accountAddressCity'],[data-component='accountAddressPostalCode'],[data-component='accountAddressState'] select,[data-component='accountAddressCountry'] select").removeClass("invalid"));

		$subscriptionComponent.find("[data-component='createAccountForm'] form")
			.removeAttr(Constants.ADDRESS_VERIFICATION_STATUSES_ATTRIBUTES.VERIFIED)
			.removeAttr(Constants.ADDRESS_VERIFICATION_STATUSES_ATTRIBUTES.USER_CERTIFIED)
			.removeAttr(Constants.ADDRESS_VERIFICATION_STATUSES_ATTRIBUTES.ERROR);
	},

	_clearEmailData($subscriptionComponent, formParentId) {
		this._setEmailDisableStatus($subscriptionComponent, /*isDisabled*/false);
		$subscriptionComponent.find("[data-component='accountEmailAddress']").val("");

		window.AccountActions.setSelectedEmailType(formParentId, "");

		ValidationHelper.removeBetterValidationPopup($subscriptionComponent.find("[data-component='accountEmailAddress'],[data-component='accountEmailType'] select").removeClass("invalid"));
	},

	_clearSubscriptionPurchaseData($subscriptionComponent, formParentId) {
		$subscriptionComponent.find("input:visible,select:visible").prop("disabled", false);
		$subscriptionComponent.find("input:not([data-component='autoRenewCheckbox.input'],[data-component='thisIsMeCheckbox.input'],[data-component='subscriptionStartDate'],[data-component='subscriptionQuantity'])").val("");
		window.AccountActions.setSelectedTitle(formParentId, "");
		window.AccountActions.setSelectedPhoneType(formParentId, "");
		window.AccountActions.setSelectedOrganizationType(formParentId, "");
		ValidationHelper.removeBetterValidationPopup($subscriptionComponent.find("input,select").removeClass("invalid"));

		this._clearAddressData($subscriptionComponent, formParentId);
		this._clearEmailData($subscriptionComponent, formParentId);
	},

	_getEventOrReturn: function(event, isDesignModeMessage, isDesignMode) {
		return ActionsHelper.getEventOrReturn(event, isDesignMode != null ? isDesignMode : window.AccountActions.isDesignMode(), isDesignModeMessage, /*preventDefaultInDesignMode*/false); //coersion, because we want to check for null or undefined
	},

	_serializeSubscriptionPurchaseData: function($subscriptionComponent) {
		var data = {};
		//Save previously entered data
		data = ActionsHelper.serializeForm($subscriptionComponent.find("form#createAccountForm"));

		return data;
	},

	_setAccountData: function(data, $component, formId) {
		//This is the first checkbox input.  If we have account data, set it.
		if (data) {
			if (!data.onlyAddressData && !data.onlyEmailData) {
				var account = data;
				if (data.type == "O") {
					account = this.organizationPrimaryContact || {};
					this._setTextInput($component, "organizationName", data.name);
					window.AccountActions.setSelectedOrganizationType(formId, data.organizationType);
				}

				this._setTextInput($component, "accountFirstName", account.firstName);
				this._setTextInput($component, "accountLastName", account.lastName);
				this._setTextInput($component, "accountMiddleName", account.middleName);
				this._setTextInput($component, "accountMiddleName", account.middleName);
				this._setTextInput($component, "accountSuffix", account.suffix);
				window.AccountActions.setSelectedTitle(formId, account.title);
			}
			if (data.address) {
				this._setTextInput($component, "accountAddressLine1", data.address.line1);
				this._setTextInput($component, "accountAddressLine2", data.address.line2);
				this._setTextInput($component, "accountAddressLine3", data.address.line3);
				this._setTextInput($component, "accountAddressLine4", data.address.line4);
				this._setTextInput($component, "accountAddressCity", data.address.city);
				this._setTextInput($component, "accountAddressPostalCode", data.address.postalCode);
				window.AccountActions.setSelectedCountry(formId, data.address.country || window.AccountStore.getDefaultCountry());
				window.AccountActions.setSelectedState(formId, data.address.state);
			}
			if (data.phone) {
				this._setTextInput($component, "accountPhoneCountryCode", data.phone.internationalCode);
				this._setTextInput($component, "accountPhoneAreaCode", data.phone.areaCode);
				this._setTextInput($component, "accountPhoneNumber", data.phone.phoneNumber);
				this._setTextInput($component, "accountPhoneExtension", data.phone.extension);
				window.AccountActions.setSelectedPhoneType(formId, data.phone.type);
			}
			if (data.email) {
				window.AccountActions.setSelectedEmailType(formId, data.email.type);
				this._setTextInput($component, "accountEmailAddress", data.email.emailAddress);
			}
			ValidationHelper.removeBetterValidationPopup($component.find("input,select").removeClass("invalid"));
		}
	},

	_setAddressDisableStatus: function($subscriptionComponent, isDisabled) {
		$subscriptionComponent.find("[data-component='accountAddressLine1'],[data-component='accountAddressLine2'],[data-component='accountAddressLine3'],[data-component='accountAddressLine4'],[data-component='accountAddressCity'],[data-component='accountAddressPostalCode'],[data-component='accountAddressState'] select,[data-component='accountAddressCountry'] select")
							.prop("disabled", isDisabled);
	},

	_setEmailDisableStatus: function($subscriptionComponent, isDisabled) {
		$subscriptionComponent.find("[data-component='accountEmailAddress'],[data-component='accountEmailType'] select").prop("disabled", isDisabled);
	},

	_setFieldDisableStatus: function($subscriptionComponent, isDisabled) {
		$subscriptionComponent.find("input:not([data-component='autoRenewCheckbox.input'],[data-component='thisIsMeCheckbox.input'],[data-component='subscriptionStartDate'],[data-component='subscriptionQuantity']),select:not([data-component='otherAddressDropdown.selector'],[data-component='otherEmailDropdown.selector'])").prop("disabled", isDisabled);
	},

	_setTextInput: function($parent, childComponentName, value) {
		$parent.find(`input[data-component="${childComponentName}"]`).val(value || "");
	}
};

module.exports = SubscriptionHelper;
